import { AuthConfig } from '@auth0/auth0-angular';

export interface Env {
  api: string;
  production: boolean;
  auth0: AuthConfig;
  calendarUrl: string;
  /**
   * Absolute base URL of the customer self-service portal (e.g.
   * https://app.appliedbiox.com). Used for the post-payment cross-app handoff
   * from the calendar booking funnel to the customer dashboard (#797).
   * Optional because not every app sets it.
   */
  customerAppUrl?: string;
  /**
   * Optional explicit override for the public marketing-site base URL (no
   * trailing slash) — e.g. to point a preview build at a staging marketing
   * origin. Left unset in normal builds: `marketingBaseUrl()` derives the
   * environment-appropriate origin from the `production` flag (dev → dev.appliedbiox.com,
   * prod → www.appliedbiox.com), so that derivation is the live default, not a
   * dead fallback.
   */
  marketingUrl?: string;
  stripePKey: string;
  portalName: string;
  stripePlanUrl: string;
  companyId: string;
  analyticsMeasurementId: string;
  stripe_package_price_1: string;
  stripe_package_price_2: string;
  stripe_package_price_3: string;
  stripe_package_price_4: string;
  stripe_package_price_5: string;
  stripe_package_price_6: string;
  stripe_package_price_7: string;
  adminEmails: string[];
  /**
   * "We are in business" maintenance switch (Gate 2). When `true`, the app's
   * router is swapped (via `withMaintenanceMode`) so every route renders the
   * shared maintenance/coming-soon page instead of the real surface. Build-time
   * flag wired through `tools/scripts/generate-env.mjs` from `MAINTENANCE_MODE`;
   * optional and defaults to live (false) when unset.
   */
  maintenanceMode?: boolean;
  /**
   * Frontend Sentry error reporting (#2191). Both must be set for reporting
   * to activate — see `sentry-error-reporting.ts` in ui-core. Build-time
   * flags wired through `tools/scripts/generate-env.mjs` from
   * `SENTRY_ENABLED_FRONTEND` / `SENTRY_DSN_FRONTEND`; optional and default
   * to fully inert when unset.
   */
  sentryEnabled?: boolean;
  /** Browser-project DSN — deliberately separate from the backend's `SENTRY_DSN`. */
  sentryDsn?: string;
}
